/**
 * Tree-shaken ECharts entry — register only chart types and components used in the app.
 * Import from here instead of `import * as echarts from 'echarts'` to keep the main bundle small.
 */
import * as echarts from 'echarts/core';
import { BarChart, GaugeChart, LineChart, MapChart, PieChart } from 'echarts/charts';
import {
  AxisPointerComponent,
  GeoComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  GaugeChart,
  MapChart,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  GeoComponent,
  VisualMapComponent,
  AxisPointerComponent,
  CanvasRenderer,
]);

export { echarts };
